import { Attachment } from "@mui/icons-material";
import { Button, Grid, Stack, Typography } from "@mui/material";
import { FileGroup } from "common/FileUpload";
import { useFileContext } from "context/FilesV2";
import { useMemo, useRef } from "react";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";

const ExpenseAttachments = ({
  settings,
  isSaving = false,
  onSave,
  showSaveButton = true,
}) => {
  const fgRefs = useRef([]);
  const { fileGroups } = useFileContext();
  const canAdd = settings?.canAdd === true;
  const canEdit = settings?.canEdit === true;
  const canDelete = settings?.canDelete === true;
  const canSaveAttachments = canAdd || canEdit;
  const isReadOnly = !canSaveAttachments;

  const AccordionTitle = () => (
    <Stack direction="row" gap={1} alignItems="center">
      <Attachment color="primary" fontSize="small" sx={{ marginLeft: "2px" }} />
      <Typography color="primary" sx={{ fontWeight: 1000 }}>
        ΣΥΝΗΜΜΕΝΑ
      </Typography>
    </Stack>
  );

  const AccordionContent = useMemo(
    () => (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {fileGroups?.map((group, index) => (
            <FileGroup
              reviewMode={false}
              isReadOnly={isReadOnly}
              canAdd={canAdd}
              canDelete={canDelete}
              key={group.id}
              id={group.id}
              ref={(el) => (fgRefs.current[index] = el)}
              title={group?.title}
              maxSize={2097152}
              maxFiles={5}
              maxBundles={group?.maxBundles}
              fields={group.fields}
              bundles={group?.bundles}
              templates={group?.templates}
            />
          ))}
        </Grid>

        {showSaveButton && canSaveAttachments && (
          <Grid item xs={12}>
            <Button
              size="small"
              variant="contained"
              disabled={isSaving}
              onClick={onSave}
              sx={{ fontWeight: 800 }}
            >
              Αποθήκευση Συνημμένων
            </Button>
          </Grid>
        )}
      </Grid>
    ),
    [
      canAdd,
      canDelete,
      canSaveAttachments,
      fileGroups,
      isReadOnly,
      isSaving,
      onSave,
      showSaveButton,
    ]
  );

  return (
    <CustomSimpleAccordion
      title={<AccordionTitle />}
      content={AccordionContent}
    />
  );
};

export default ExpenseAttachments;
